import React from "react";

import getIcon from "src/common/components/icons/technologies";

import * as S from "./ServiceNode.styles";

export interface ServiceNodeProps {
  name: string;
  id: string;
}

const ServiceNode = ({ name, id }: ServiceNodeProps) => {
  return (
    <S.Svg id={`svg-node-${id}`} width="57" height="57" viewBox="0 0 57 57">
      <defs>
        <filter
          id={`shadow-node-${id}`}
          width="200%"
          height="200%"
          x="-50%"
          y="-50%"
        >
          <feDropShadow
            dx="0"
            dy="3"
            stdDeviation="6"
            floodColor="rgba(75, 97, 128, 0.32)"
            floodOpacity="2"
          />
        </filter>
      </defs>
      <S.Node id={`node-${id}`} width="40" height="40">
        <S.Rect width="40" height="40" rx="14" ry="14" x="8" y="0" />
        <image
          x="12.5"
          y="14"
          width="20"
          height="20"
          xlinkHref={`data:image/svg+xml;base64,${window.btoa(
            getIcon(
              name,
              "12.5",
              "14",
              "20",
              "20",
              "var(--icon-slate-fill,var(--slate))"
            )
          )}`}
        />
      </S.Node>
    </S.Svg>
  );
};

export default ServiceNode;
